export type CompleteEnrolementRequest = {
  otp: string,
  userEmail: string
};

export const CompleteEnrolementRequestInit: CompleteEnrolementRequest = {
  otp: "",
  userEmail: ""
};

